import React from 'react';
import './NamesColumns.css'; // Import your stylesheet

function NamesColumns({ header1, namesArray1, header2, namesArray2 }) {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div>
                <h3 style={{ color: 'GrayText', padding: 10 }}>{header1}</h3>
                <div className="columnContainer">
                    {namesArray1.map((name, index) => (
                        <p key={index}>{name}</p>
                    ))}
                </div>
            </div>
            <div>
                <h3 style={{ color: 'GrayText', padding: 10 }}>{header2}</h3>
                <div className="columnContainer">
                    {namesArray2.map((name, index) => (
                        <p key={index}>{name}</p>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default NamesColumns;
